import Layout from "hocs/layouts/Layout"
import NewTrip from "components/Trip/NewTrip"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

function NewTrips({
    isAuthenticated
}){

    return(
        <Layout>
            {isAuthenticated ? 
             <NewTrip /> :
            <div className='py-20 text-center'>
                <h1 className='text-2xl font-semibold mb-5'>Inicia sesión para publicar trips</h1>
                <Link 
                    to='/login'
                    className="rounded-3xl px-4 py-2 bg-blue-green hover:bg-blue-green-dark text-white ">
                    Iniciar sesion
                </Link>
            </div>
            }
        </Layout>
    )
}

const mapStateToProps=state=>({
    isAuthenticated: state.auth.isAuthenticated,
})

export default connect(mapStateToProps,{
})(NewTrips)